export default __webpack_public_path__ + "static/media/logo-itai.b4936b22.png";